import { useAuth } from '../../contexts/AuthContext';
import { AlertCircle } from 'lucide-react';

interface PhoneVerificationAlertProps {
  onVerifyClick?: () => void;
}

const PhoneVerificationAlert = ({
  onVerifyClick,
}: PhoneVerificationAlertProps) => {
  const { user } = useAuth();
  const showAlert = user && !user.phoneVerified;

  if (!showAlert) return null;

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-start gap-3">
      <div className="flex-shrink-0">
        <AlertCircle className="h-5 w-5 text-amber-600" />
      </div>
      <div className="flex-1">
        <h3 className="text-sm font-medium text-amber-800">
          Phone Verification Required
        </h3>
        <p className="text-sm text-amber-700 mt-1">
          Please verify your phone number to ensure account security and enable
          all features.
        </p>
      </div>
      <button
        onClick={onVerifyClick}
        className="flex-shrink-0 text-sm font-medium text-amber-800 hover:text-amber-900 underline"
      >
        Verify Now
      </button>
    </div>
  );
};

export default PhoneVerificationAlert;
